import { Component, OnInit, ViewChild } from '@angular/core';
import { DocumentoNegociableService } from '../../services/documento-negociable/documento-negociable.service';
import { CavaliService } from 'app/services/Cavali/Cavali.service';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { RiesgoService } from '../../services/riesgo/riesgo.service';
import { Observable } from 'rxjs/Rx';
import { startWith, map } from 'rxjs/operators';
import { EmpresasService } from '../../services/empresas/empresas.service';
import { FormControl,FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { FiltrosDocumentosNegociables } from '../../models/FiltrosDocumentosNegociables';
import Swal from "sweetalert2";
import { LoginService } from 'app/services/login/login.service';
import { environment } from 'environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
declare var $: any;
@Component({
  selector: 'app-listado-doc-neg',
  templateUrl: './listado-doc-neg.component.html',
  styleUrls: ['./listado-doc-neg.component.css']
})
export class ListadoDocNegComponent implements OnInit {
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  archivoEnBase64 : any;
  tipoAdjunto : number;
  DNegociable : any;
  adjuntarPDF : boolean;
  selectArchivo : boolean;
  ruc = new FormControl();
  tipoComprobante :string;
  formExtornar: FormGroup;
  estado ="R";
  id;
  adjuntoEstado : string ='T';
  filteredProveeedor: Observable<any[]>;
  proveedoresArr;
  tipoEmsion:string ;
  ruta : string;
  isRecibo:boolean = true;
  isLetra:boolean = true;
  user :any;
  idEncrip:any;
  
  relacionDNF: boolean;
  comprobante:any;
  fondos: any = [];
  garantias: any = [];  
  arraySend: any = [];

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  // usuarios:any[]=[];
  pageSizeOptions = [15,20,30,50,100,200];
  docNegociables:any = [];
  loading:boolean;
  displayedColumns: string[] = 
            ['checked','Tipo_Comprobante','Número','NombreComercial','RazonSocialAdquirente','Fecha_Emision',
            'Fecha_de_Pago','Moneda','VNPP','Estado','Codigo_Valor'];
  dataSource :any; 
   DTOFiltrosDocNeg :FiltrosDocumentosNegociables = new FiltrosDocumentosNegociables();
  constructor( private negociablesService:DocumentoNegociableService,
               private riesgo: RiesgoService, 
               private empresasService: EmpresasService, 
               private cavaliService : CavaliService,
               private router:Router,
               private loginService:LoginService,
               private http : HttpClient,) {
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.adjuntarPDF = false;
    this.selectArchivo = false;
    this.cargarListadoCompleto();
    this.ObtenerEmpresasCombo();  
    this.listarFondos();  
    
   }
  ngOnInit() {
    
    let rutas = this.router.url.split("/",3);
    this.ruta = rutas[2];

    if (this.ruta == 'recibo'){ 
        this.tipoComprobante = 'R';
        this.DTOFiltrosDocNeg.Tipo_Comprobante = 'R';
        this.isRecibo = true;
        this.isLetra = false;
    }else if (this.ruta == 'factura'){
      this.isRecibo = false;
      this.isLetra = false;
      this.tipoComprobante = 'F';
      this.DTOFiltrosDocNeg.Tipo_Comprobante  = 'F';
    }
    else if  (this.ruta == 'letra'){
      this.isLetra = true;
      this.isRecibo = false;
      this.tipoComprobante = 'L';
      this.DTOFiltrosDocNeg.Tipo_Comprobante  = 'L';
    }
    else if  (this.ruta == 'facturacc'){
      this.isLetra = false;
      this.isRecibo = false;
      this.tipoComprobante = 'FF';
      this.DTOFiltrosDocNeg.Tipo_Comprobante  = 'FF';
    }
     this.idEncrip=CryptoJS.MD5(this.user.id_user.toString().trim()).toString(); 
    /*this.idEncrip=Buffer.from(this.user.id_user.toString()).toString('base64');*/
    this.DTOFiltrosDocNeg.user_id=this.idEncrip;
  }

  CerrarVenta(){
   
    this.selectArchivo = false;
   
 }

   CerrarVentaAdjunto(){
   
    this.adjuntarPDF = false;
    this.filtradoDocNegociables();
 
  }  
  cerrarPopUp() {
    this.relacionDNF = false;
    this.arraySend = [];
  }
  abrirRelacionDNF(comprobante, flag) {
   
    
      this.comprobante = ""; 
      
      this.arraySend.push(comprobante);
      this.relacionDNF = true;
      
  }
  listarFondos() {
    this.riesgo.obtenerFondos().subscribe(
      resp => {
        this.fondos = resp
       // this.fondos = this.fondos.filter(item => item.Moneda == this.PropuestaOperacion.Moneda || item.Multiples_Moneda == 'A');
      }, (err: HttpErrorResponse) => {
        this.loading = false;       
        
        Swal.fire({
          title: 'error',
          text: "LISTA FONDOS NO OBTENIDO. ",
          type: "error",
          allowOutsideClick: false
        });
      });
  }

  abrirSelecTipoArchivo(fila : string , tipoEmision?: string){
    if (tipoEmision =='Electrónico'){
      
      this.tipoEmsion='E';
    }else{
      this.tipoEmsion='F'
    }
    this.selectArchivo = !this.selectArchivo;
    this.DNegociable = fila;
  }

  abrirAdjuntarPDF(data : any ){
    this.negociablesService.dataNegociable = data;
    this.adjuntarPDF = true;
 

  
  }

  darBajaDocumento(idComprobante){
    Swal.fire({
      title: '',
      text: '¿Estás seguro en dar de baja el documento?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, dar de baja',
      cancelButtonText: 'No, cancelar.',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        this.formExtornar = new FormGroup({
          'idComprobante' : new FormControl(idComprobante),
          'Estado' : new FormControl('B'),
          'Baja_Usuario': new FormControl(this.user.Usuario)
        })  
        this.negociablesService.actualizarDocNegociable(this.formExtornar.getRawValue(),idComprobante)
        .subscribe(res => { 
          Swal.fire(
            '¡Documento dado de baja!',
            'El documento fue dado de baja exitosamente.',
            'success'
          ).then(resp => {
            if (resp.value == true) {
              this.filtradoDocNegociables();
            }
          });
          
        },
        err => {
          Swal.fire({
            title: "Error",
            text: "No se pudo dar de baja el documento.",
            type: "error",
            allowOutsideClick: false,
            heightAuto: false
          });
        }
        )
      }
    })
  }

  ExtornarDocumento(idComprobante){
    Swal.fire({
      title: '',
      text: '¿Estás seguro de extornar el documento?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, extornar',
      cancelButtonText: 'No, cancelar.',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        this.formExtornar = new FormGroup({
          'idComprobante' : new FormControl(idComprobante),
          'Estado' : new FormControl('R',)
        })  
        this.negociablesService.actualizarDocNegociable(this.formExtornar.getRawValue(),idComprobante)
        .subscribe(res => { 
          Swal.fire({
            title: '¡Documento extornado!',
            text: 'El documento fue extornado exitosamente.',
            type: 'success',
            heightAuto: false
          }).then(resp1 => {
            if (resp1.value == true) {
              this.filtradoDocNegociables();
            }
          });
          
        },
        err => {
          Swal.fire({
            title: "Error",
            text: "No se pudo extornar el documento.",
            type: "error",
            allowOutsideClick: false,
            heightAuto: false
          });
        }
        )
      } 
    })

  }

  EditarDocumento(id : string , tipoEmision?: string){

    if(this.isRecibo){
      this.loginService.clickGuard = true;
      this.router.navigate(['/negociables/recibo/RH/editar/',id]);
    }
    else if(this.isLetra){
      this.loginService.clickGuard = true;
      this.router.navigate(['/negociables/letra/LC/editar/',id]);
    }else if(this.tipoComprobante == 'FF'){      
      this.loginService.clickGuard = true;
      this.router.navigate(['/negociables/facturacc/FE/editar/',id]);
    }else{
      if(tipoEmision == "Físico"){
        this.loginService.clickGuard = true;
        this.router.navigate(['/negociables/factura/FF/editar/',id]);
      }else{
        this.loginService.clickGuard = true;
        this.router.navigate(['/negociables/factura/FE/editar/',id]);
      }
    }
  }

  verDocumento(id : string , tipoEmision?: string){
    if(this.isRecibo){
      this.loginService.clickGuard = true;
      this.router.navigate(['/negociables/recibo/RH/ver/',id]);
    }
    else if(this.isLetra){
      this.loginService.clickGuard = true;
      this.router.navigate(['/negociables/letra/LC/ver/',id]);
    }
    else if(this.tipoComprobante == 'FF'){
      this.loginService.clickGuard = true;
      this.router.navigate(['/negociables/facturacc/FE/ver/',id]);
    }else{
      if(tipoEmision == "Físico"){
        this.loginService.clickGuard = true;
        this.router.navigate(['/negociables/factura/FF/ver/',id]);
      }else{
        this.loginService.clickGuard = true;
        this.router.navigate(['/negociables/factura/FE/ver/',id]);
      }
    }

  }
  
  cargarListadoCompleto(){
    this.loading = true;

    this.negociablesService.obtenerDocNegociables()
    .subscribe(res => {
      
      this.docNegociables = res;
      
      this.negociablesService.dataNegociables = this. docNegociables ;
      this.loading = false;
      if(this.tipoComprobante == 'FF'){
        this.docNegociables = this.docNegociables.filter(elem => elem.Estado == "Registrado" && elem.recompra == 1)
      }else{
        this.docNegociables = this.docNegociables.filter(elem => elem.Estado == "Registrado" && elem.recompra == 0)
      }
      
      this.dataSource = new MatTableDataSource( this.docNegociables);
      
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      
    });
  }

  alerta(){
    alert('asd');
  }
  
  filtradoDocNegociables(){
    this.loading = true;
  
    if (this.ruc.value == null){
      this.id = "";
      this.DTOFiltrosDocNeg.Id = "";
    }
    if (this.DTOFiltrosDocNeg.CodOperacion != ''){
      this.id = "";
      this.DTOFiltrosDocNeg.Id = "";
      this.DTOFiltrosDocNeg.Numero = "";
    }
 
    this.negociablesService.FiltrarDatosListadoDocNegociables(this.DTOFiltrosDocNeg)
    .subscribe( resp => { 
      this.docNegociables = resp
      this.negociablesService.dataNegociables = this. docNegociables ;
      this.dataSource = new MatTableDataSource(this.docNegociables); 
      console.log("DATOS FILTRADOS",this.dataSource)     
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      this.pageSizeOptions = [15,20,30,50,100,200];
      this.loading = false;

    })

  }

  ObtenerEmpresasCombo() {
    this.proveedoresArr = JSON.parse(sessionStorage.getItem('lstProvCbo'));

      this.filteredProveeedor = this.ruc.valueChanges
      .pipe(
        startWith(""),
        map(state =>
          state ? this._filterProv(state) : this.proveedoresArr.slice()
        )
      );
  

   
  }

  private _filterProv(value: string): any[] {
    const filterValue = value.toString().toLowerCase();

    return this.proveedoresArr.filter(
      state => (state.Razon_Social.toLowerCase().includes(filterValue) === true) ||  (state.Num_Doc_Identificacion.toLowerCase().includes(filterValue) === true)
    );
  }

  obtenerId(termino :string){
    this.id = termino
    this.DTOFiltrosDocNeg.Id = termino;
  }
  
  EnterobtenerRucRazSocialProv(termino :string = ''){
    
    if (termino != null && termino != ''){
     
      let termino1 = termino.toLowerCase();                   
  
      for( let p of this.proveedoresArr){
  
          let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1)  >= 0){
            this.id = p.idEmpresa;
            this.DTOFiltrosDocNeg.Id = p.idEmpresa;
          }
  
      }

    }

  }
  
  registrarCavali(idComprobante){
    this.loading = true;
    Swal.fire({
      title: 'Factrack - Cavali',
      text: '¿Deseas enviar el documento Nro. '+ idComprobante+' al proceso de registro en la plataforma Cavali?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Si',
      cancelButtonColor: '#d33',
      cancelButtonText: 'No',
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        this.cavaliService.registrarCavali(idComprobante).subscribe( res => {
          this.loading = false;
          Swal.fire({
            title: 'Satisfactorio!',
            text: 'Documento Nro. '+ idComprobante+' ha sido enviado para su registrar en Cavali.',
            type: 'success',
            heightAuto: false
          })
          let rpt = res['data'];
          this.showNotification('success','top','right','Documento Nro. '+ idComprobante + ' ' + rpt);          
          this.filtradoDocNegociables();
        }, err => {
          let error = "";
          if(err.status == "406"){
            error = err.error.data;
          } else {
            error = err.error.error;
          }      
          this.showNotification('danger','top','right','Error al intentar registrar documento en Cavali. \n' + error);
        });
        
      }
    })
  }
  downloadresource(urlsend,serie,numero,ruc){
    const headers = new HttpHeaders(  
      { 'Access-Control-Allow-Headers': 'Content-Type',
    'Access-Control-Allow-Methods': 'GET',
    'Access-Control-Allow-Origin': '*'
  });
  var array_url = urlsend.split("/");
  console.log(array_url);
  urlsend = "/starkengine.appspot.com/documentos_negociables/"+array_url[5]+"/"+array_url[6];
    var returnss= this.http.get(urlsend,{ headers,responseType:'blob' }).subscribe(
      data =>{
        var element = document.createElement('a');
        var blob = new Blob([data],{
          type:'text/xml'
        })
        var url = URL.createObjectURL(blob);
        element.href = url;
        element.setAttribute('download',serie+'-'+numero+'_'+ruc+'.xml');
        document.body.appendChild(element);
        element.click();
      }
    );
    
  }
  showNotification(type,from,align,message){
    
    //const type = ['','info','success','warning','danger']; => tipo de notificacion
    //from = [Top,bottom,etc] => orientacion vertical
    //align = center, left, right => orientacion horizontal
  
    $.notify({
        icon: "notifications",
        message: message
    },{
        type: type,
        timer: 4000,
        placement: {
            from: from,
            align: align
        },
        template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
          '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
          '<i class="material-icons" data-notify="icon">notifications</i> ' +
          '<span data-notify="title">{1}</span> ' +
          '<span data-notify="message">{2}</span>' +
          '<div class="progress" data-notify="progressbar">' +
            '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
          '</div>' +
          '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }
  ObtenerFNCavali(idComprobante){
    this.loading = true;
    Swal.fire({
      title: 'Factrack - Cavali',
      text: '¿Deseas obtener el Codigo Valor para el documento Nro. '+ idComprobante+' de Cavali?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Si',
      cancelButtonColor: '#d33',
      cancelButtonText: 'No',
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        
        this.cavaliService.obtenerFNCavali(idComprobante).subscribe( res => {
          
        this.loading = false;
          let rpt = res['data'];
          Swal.fire({
            title: 'Satisfactorio!',
            text: 'Se ha obtenido los datos del Documento Nro. '+ idComprobante+'.',
            type: 'success',
            heightAuto: false
          })
          this.filtradoDocNegociables();
          this.showNotification('success','top','right','Documento Nro. '+ idComprobante + ' ' + rpt);

        }, err => {
          let error = "";
          if(err.status == "406"){
            error = err.error.data;
          } else {
            error = err.error.error;
          }      
          this.showNotification('danger','top','right','Error al intentar obtener código valor del documento en Cavali. \n' + error);
        });
        
      }
    })
  }

}
